import { render } from "./hr-payroll-mark.vue?vue&type=template&id=47ce8e4a&scoped=true"
import script from "./hr-payroll-mark.vue?vue&type=script&lang=js"
export * from "./hr-payroll-mark.vue?vue&type=script&lang=js"

import "./hr-payroll-mark.vue?vue&type=style&index=0&id=47ce8e4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ce8e4a"]])

export default __exports__